export default function authHeader() {
  const authToken = localStorage.getItem('auth_token');

  if (authToken) {
    return {Authorization: 'Bearer ' + authToken};
  } else {
    return {};
  }
}
